<template>
  <div class="c-product-thumb-link">
    <div class="c-product-thumb" :class="labelClass">
      <div class="c-show-labels-on-top">
      <div v-for="(label, index) in item.Labels" :key="`label-${index}`" class="c-product-label u-font-small" :class="'color-'+label.split(' ').join('-').toLowerCase()">
        {{ label }}
      </div>
      </div>
      <div class="c-discount-label u-font-small" v-if="item.DiscountPercentage && hasAccess">
        -{{ item.DiscountPercentage }}%
      </div>
      <router-link :to="{ name: 'ProductDetailview', params: { id: item.Id }, query: getQuery() }" class="c-product-thumb-image-link">
        <div v-if="Object.keys(item.Images).length > 0">
          <div class="c-product-thumb-image__slide" v-for="(image, index) in Images" :key="index" v-if="index === activeItem">
            <img :src="image.src" alt="">
          </div>
        </div>
        <div v-else>
          <img width="250px" src="@/assets/images/no_image_x300.png" alt="">
        </div>
      </router-link>

      <div v-if="Images && Images.length > 1" class="c-product-thumb-overlay">
        <div class="c-product-thumb-thumbs">
          <button v-for="(image, index) in Images"
                  class="c-button c-button--reset c-product-thumb-thumbs__item"
                  :class="{'is-active': index === activeItem}"
                  type="button"
                  :key="index"
                  @click="selectSlide(index)">
            <img :src="image.src" alt="">
          </button>
        </div>
      </div>

      <div class="c-product-thumb-info">
        <div>
          <strong>{{item.BrandName}} - {{item.Name}}</strong><br>
          <span class="u-font-small u-opacity-50">Model {{ item.ErpId }}</span>
        </div>
      </div>

      <template v-if="hasAccess">
        <div v-if="!isCustomerHidden && isCustomer" class="c-wrapper-price c-retail-price u-font-small">
          <span>{{ $t('product.line.retail_price') }}</span>
          <span class="c-price">{{ item.RetailFromPrice | currency(customerCurrencySymbol) }}</span>
        </div>
      </template>

      <div class="c-wrapper-price c-suggested-price u-font-small" v-if="showOriginalPrice">
        <span>{{ $t('product.line.from_price') }}</span>
        <span class="c-price">{{ item.OriginalFromPrice | currency(customerCurrencySymbol) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import imagesLoaded from 'vue-images-loaded'

  export default {
    props: {
      item: {type: Object},
      stockOnly: {type: Boolean}
    },
    directives: {
      imagesLoaded
    },
    data() {
      return {
        activeItem: 0,
        activeProductColor: null,
        sliderOptions: {
          initialIndex: 0,
          prevNextButtons: false,
          pageDots: false,
          wrapAround: true,
          imagesLoaded: true,
          draggable: false
        }
      }
    },
    computed: {
      Images() {
        let output = [];

        this.item.Images.forEach(image => {
          output.push({
            src: image.replace('[WIDTH]', 250).replace('[HEIGHT]', 250)
          })
        });

        return output
      },
      isCustomerHidden() {
        return this.$store.getters.isCustomerHidden;
      },
      isCustomer() {
        return this.$store.getters.isCustomer;
      },
      labelClass() {
        return this.item.Labels.length === 1 ? 'label-' + this.item.Labels[0].split(' ').join('-').toLowerCase() : null
      },
      customerCurrencySymbol() {
        return this.$store.getters.userInfo.customerCurrencySymbol;
      },
      hasAccess(){
        return this.item.CustomerHasAccess === true && this.item.RetailFromPrice >= 0;
      },
      showOriginalPrice(){
        return this.item.OriginalFromPrice >= 0;
      }
    },
    methods: {
      selectSlide(slide) {
        console.log(slide)
        this.activeItem = slide;
        this.activeProductColor = this.getProductColorFromImageUrl(this.item.Images[slide]);
      },
      getProductColorFromImageUrl(url) {
        let idx = url.indexOf('color/');
        if(idx === -1) return null;

        let colorEnd = url.indexOf('/', idx + 6);
        if(colorEnd === -1) return url.substring(idx+6);

        return url.substring(idx+6, colorEnd);
      },
      getQuery() {
        let query = {};

        if (this.activeProductColor) {
          query['color'] = this.activeProductColor;
        }

        if (this.stockOnly) {
          query['stockOnly'] = this.stockOnly;
        }

        return query;
      }
    }
  }
</script>

<style lang="scss" scoped>

  @import "~@/assets/scss/private";

  $thumbwidth: em(100px);
  $overlayPadding: em($global-spacing-unit);

  .c-show-labels-on-top {
    position: absolute !important;
    display: flex;
  }
  .c-product-thumb {
    z-index: 1;
    perspective: 250px;
    position : relative;

    > * {
      position: relative;
    }

    &:hover {
      z-index: 2;
      .c-product-thumb-overlay {
        z-index : -1;
        visibility: visible;
        opacity: 1;
        transition: .2s;
        transform: none;
      }
    }
  }

  .c-product-thumb-link {
    text-decoration: none;
  }

  .c-product-thumb-image-link {
    display: block;
    position: relative;
    z-index: 2;
  }

  .c-product-thumb-overlay {
    content: '';
    position: absolute;
    width: calc(100% + #{$thumbwidth + $overlayPadding*3});
    height: calc(100% + #{$overlayPadding*2});
    left: -$overlayPadding;
    top: -$overlayPadding;
    box-shadow: 0 0 30px 0 rgba($color-base, .1);
    z-index: 1;
    background-color: white;
    padding: $overlayPadding;
    visibility: hidden;
    opacity: 0;
    transform-origin: top left;

    transform: rotateX(-3deg) rotateY(3deg);
  }

  .c-product-thumb-thumbs {
    margin-left: auto;
    width: $thumbwidth;
    height: 100%;
    overflow-y: auto;

    &__item {
      width: 100%;
      border: 1px solid transparent;
      height: 55px;

      img {
        height: 100%;
        object-fit: cover;
      }

      &:not(:last-child) {
        margin-bottom: em($global-spacing-unit-small);
      }

      &.is-active, &:focus, &:hover {
        background-color: transparent;
        box-shadow: none !important;
        border: 1px solid $color-neutral;
      }

    }
  }

  .c-product-thumb-image__slide {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0;
    img {
      width: 250px;
      height: 250px;
      object-fit: contain;
    }
  }

  .c-product-thumb-info {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    strong {
      display: inline-block;
      min-height: 50px;
    }
  }

  .c-price {
    color: white;
    padding: em($global-spacing-unit-tiny);
    font-weight: $medium;
    @include rfs($font-size-small);
  }

  .c-wrapper-price {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 5px;
  }

  .c-retail-price .c-price {
    color: $color-success;

    .label-promo & {
      color: $color-promo;
    }
    .label-new & {
      color: $color-new;
    }
    .label-bestseller & {
      color: $color-bestseller;
    }
    .label-advantage-pack & {
      color: $color-advantage-pack;
    }
    .label-popular & {
      color: $color-popular;
    }
    .label-super-deal & {
      color: $color-super-deal;
    }
    .label-daily-offer & {
      color: $color-daily-offer;
    }
    .label-web-only & {
      color: $color-web-only;
    }
    .label-outlet & {
      color: $color-outlet;
    }
    .label-limited-edition & {
      color: $color-limited-edition;
    }
    .label-seen-on-tv & {
      color: $color-seen-on-tv;
    }
    .label-campagne-model & {
      color: $color-campagne-model;
    }
    .label-last-pieces & {
      color: $color-last-pieces;
    }
    .label-marketing-model & {
      color: $color-marketing-model;
    }
    .label-vegan & {
      color: $color-vegan;
    }
  }

  .c-suggested-price .c-price {
    background-color: $color-success;

    .label-promo & {
      background-color: $color-promo;
    }
    .label-new & {
      background-color: $color-new;
    }
    .label-bestseller & {
      background-color: $color-bestseller;
    }
    .label-advantage-pack & {
      background-color: $color-advantage-pack;
    }
    .label-popular & {
      background-color: $color-popular;
    }
    .label-super-deal & {
      background-color: $color-super-deal;
    }
    .label-daily-offer & {
      background-color: $color-daily-offer;
    }
    .label-web-only & {
      background-color: $color-web-only;
    }
    .label-outlet & {
      background-color: $color-outlet;
    }
    .label-limited-edition & {
      background-color: $color-limited-edition;
    }
    .label-seen-on-tv & {
      background-color: $color-seen-on-tv;
    }
    .label-campagne-model & {
      background-color: $color-campagne-model;
    }
    .label-last-pieces & {
      background-color: $color-last-pieces;
    }
    .label-marketing-model & {
      background-color: $color-marketing-model;
    }
    .label-vegan & {
      background-color: $color-vegan;
    }
  }

  .c-discount-label {
    position: absolute;
    right:0;
    top:0;
    display: inline-block;
    padding: em($global-spacing-unit-tiny);
    color: $color-new;
    font-weight: 800;
    text-transform: capitalize;
    z-index: 10;
  }

  .c-product-label {
    left: 0;
    top: 0;
    display: inline-block;
    padding: em($global-spacing-unit-tiny);
    color: $color-white;
    text-transform: capitalize;
    z-index: 10;

    &.color-promo {
      background-color: $color-promo;
    }
    &.color-new {
      background-color: $color-new;
    }
    &.color-bestseller {
      background-color: $color-bestseller;
    }
    &.color-advantage-pack {
      background-color: $color-advantage-pack;
    }
    &.color-popular {
      background-color: $color-popular;
    }
    &.color-super-deal {
      background-color: $color-super-deal;
    }
    &.color-daily-offer {
      background-color: $color-daily-offer;
    }
    &.color-web-only {
      background-color: $color-web-only;
    }
    &.color-outlet {
      background-color: $color-outlet;
    }
    &.color-limited-edition {
      background-color: $color-limited-edition;
    }
    &.color-seen-on-tv {
      background-color: $color-seen-on-tv;
    }
    &.color-campagne-model {
      background-color: $color-campagne-model;
    }
    &.color-last-pieces {
      background-color: $color-last-pieces;
    }
    &.color-marketing-model {
      background-color: $color-marketing-model;
    }
    &.color-vegan {
      background-color: $color-vegan;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/shop/ProductThumb.vue